// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as Swiper from "swiper";
import * as Js_dict from "@rescript/std/lib/es6/js_dict.js";
import * as Caml_option from "@rescript/std/lib/es6/caml_option.js";
import * as Core from "swiper/core";
import * as React from "swiper/react";
import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as BoardOfDirectorsCarousel__Arrows$PrezzeeRibbon from "./BoardOfDirectorsCarousel__Arrows.bs.js";

import 'swiper/swiper-bundle.min.css'
;

var buttonDisabled = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.opacity(0.3),
      BsCssJs$PrezzeeRibbon.cursor("notAllowed"),
      BsCssJs$PrezzeeRibbon.pointerEvents("none")
    ]);

var Styles = {
  buttonDisabled: buttonDisabled
};

var breakpoints = Js_dict.fromList({
      hd: [
        "0",
        {
          slidesPerView: 1.0,
          spaceBetween: 0,
          slidesPerGroup: 1
        }
      ],
      tl: {
        hd: [
          "420",
          {
            slidesPerView: 2.3,
            spaceBetween: 0,
            slidesPerGroup: 1
          }
        ],
        tl: {
          hd: [
            "480",
            {
              slidesPerView: 2.3,
              spaceBetween: 0,
              slidesPerGroup: 1
            }
          ],
          tl: {
            hd: [
              "550",
              {
                slidesPerView: 2.3,
                spaceBetween: 0,
                slidesPerGroup: 1
              }
            ],
            tl: {
              hd: [
                "600",
                {
                  slidesPerView: 2.3,
                  spaceBetween: 0,
                  slidesPerGroup: 1
                }
              ],
              tl: {
                hd: [
                  "640",
                  {
                    slidesPerView: 3.3,
                    spaceBetween: 0,
                    slidesPerGroup: 1
                  }
                ],
                tl: {
                  hd: [
                    "700",
                    {
                      slidesPerView: 3.3,
                      spaceBetween: 0,
                      slidesPerGroup: 1
                    }
                  ],
                  tl: {
                    hd: [
                      "850",
                      {
                        slidesPerView: 3.5,
                        spaceBetween: 0,
                        slidesPerGroup: 1
                      }
                    ],
                    tl: {
                      hd: [
                        "950",
                        {
                          slidesPerView: 3.9,
                          spaceBetween: 0,
                          slidesPerGroup: 1
                        }
                      ],
                      tl: {
                        hd: [
                          "1000",
                          {
                            slidesPerView: 3.9,
                            spaceBetween: 0,
                            slidesPerGroup: 1
                          }
                        ],
                        tl: {
                          hd: [
                            "1050",
                            {
                              slidesPerView: 3.1,
                              spaceBetween: 0,
                              slidesPerGroup: 1
                            }
                          ],
                          tl: {
                            hd: [
                              "1150",
                              {
                                slidesPerView: 3.5,
                                spaceBetween: 0,
                                slidesPerGroup: 1
                              }
                            ],
                            tl: {
                              hd: [
                                "1300",
                                {
                                  slidesPerView: 4.3,
                                  spaceBetween: 0,
                                  slidesPerGroup: 1
                                }
                              ],
                              tl: {
                                hd: [
                                  "1450",
                                  {
                                    slidesPerView: 4.3,
                                    spaceBetween: 0,
                                    slidesPerGroup: 1
                                  }
                                ],
                                tl: {
                                  hd: [
                                    "1600",
                                    {
                                      slidesPerView: 4.8,
                                      spaceBetween: 0,
                                      slidesPerGroup: 1
                                    }
                                  ],
                                  tl: {
                                    hd: [
                                      "1750",
                                      {
                                        slidesPerView: 5.3,
                                        spaceBetween: 0,
                                        slidesPerGroup: 1
                                      }
                                    ],
                                    tl: {
                                      hd: [
                                        "1900",
                                        {
                                          slidesPerView: 5.5,
                                          spaceBetween: 0,
                                          slidesPerGroup: 1
                                        }
                                      ],
                                      tl: {
                                        hd: [
                                          "2050",
                                          {
                                            slidesPerView: 6.0,
                                            spaceBetween: 0,
                                            slidesPerGroup: 1
                                          }
                                        ],
                                        tl: /* [] */0
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    });

var Settings = {
  breakpoints: breakpoints
};

function BoardOfDirectorsCarousel(props) {
  var arrowStyles = props.arrowStyles;
  var arrowStyles$1 = arrowStyles !== undefined ? arrowStyles : "";
  Curry._1(Core.Swiper.use, [Swiper.Navigation]);
  var navigation = {
    nextEl: ".navigation-next",
    prevEl: ".navigation-prev",
    hideOnClick: false,
    disabledClass: buttonDisabled,
    hiddenClass: "",
    lockClass: ""
  };
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsx(BoardOfDirectorsCarousel__Arrows$PrezzeeRibbon.make, {
                      prevArrowClass: "navigation-prev",
                      nextArrowClass: "navigation-next",
                      className: arrowStyles$1
                    }),
                JsxRuntime.jsx(React.Swiper, {
                      breakpoints: Caml_option.some(breakpoints),
                      children: props.children,
                      navigation: navigation
                    })
              ]
            });
}

var CarouselArrows;

var make = BoardOfDirectorsCarousel;

export {
  Styles ,
  Settings ,
  CarouselArrows ,
  make ,
}
/*  Not a pure module */
